import { z } from 'zod'

import { HOUSEHOLD_STEPS } from '@flows/configs/householdAt/constants'
import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'

const household_at_prev_insurance = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getHelperPath('insurance_owned')]: z.boolean(),
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_householdAt:steps.prev_insurance.title',
        },
      },
      {
        type: 'yesNo',
        shouldTrackValues: true,
        name: params.helperFunctions.getHelperPath('insurance_owned'),
      },
    ],
    subFlow: params.subFlow,
    nextStepConfig: {
      valuePath: params.helperFunctions.getHelperPath('insurance_owned'),
      valueToStepName: {
        true: HOUSEHOLD_STEPS.household_at_number_of_previous_claims,
        false: HOUSEHOLD_STEPS.household_at_contact_details,
      },
    },
  }) as const satisfies AnyStepConfiguration

export default household_at_prev_insurance
